import type { LabelHTMLAttributes } from 'react';
import { cn } from '../foundation/cn';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  readonly required?: boolean;
}

export function Label({ required = false, className, children, ...rest }: LabelProps): JSX.Element {
  return (
    <label className={cn('text-sm font-medium text-fg', className)} {...rest}>
      {children}
      {required && <span className="ms-0.5 text-danger">*</span>}
    </label>
  );
}
